import React, { useEffect, useState } from "react";
import {
  fetchApprovedCustomAnswersFromFirestore,
  fetchAndSave,
} from "../firebase/fetchAndSave";
import Logo from "../images/Logo";
import BubbleTail from "../icons/bubbleTail";
import PersonIcon from "../icons/personIcon";

export default function NovartisHealthImprovement() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchAndSave();
      const data = await fetchApprovedCustomAnswersFromFirestore();
      setAnswers(data);
    };
    fetchData();

    const interval = setInterval(fetchData, 600000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (answers.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("parallax-show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );

    const wrappers = document.querySelectorAll(".bubble-icon-wrapper");
    wrappers.forEach((el) => observer.observe(el));

    return () => {
      wrappers.forEach((el) => observer.unobserve(el));
    };
  }, [answers]);

  const colorPalette = ["#FFC100", "#0460A9", "#FF585D"]; // yellow, blue, red
  const startingIndex = Math.floor(Math.random() * colorPalette.length);

  function getColorByIndex(index) {
    return colorPalette[(startingIndex + index) % colorPalette.length];
  }

  return (
    <div className="content">
      <Logo
        style={{
          height: "85px",
          width: "27%",
        }}
      />
      <p className="description">
        The responses below are submissions from fellow delegates at NHS
        ConfedExpo 2025 to the “Other” answer option for the question “What more
        could Novartis do to reduce health inequalities and improve population
        health in the UK?”
      </p>
      <p className="note">
        Please note - the answers on this screen are refreshed every 10 minutes.
      </p>

      {loading && (
        <div className="formOverlay">
          <div className="loader"></div>
        </div>
      )}

      <div className="bubbles-container">
        {answers.map((item, index) => {
          const fillColor = getColorByIndex(index);
          const isYellow = fillColor === "#FFC100";
          const tailSide = index % 2 === 0 ? "tail-left" : "tail-right"; // alternate
          /*     const randomMarginTop = Math.floor(Math.random() * 41) - 20;
    const randomMarginLeft = Math.floor(Math.random() * 41) - 20; */
          const randomZIndex = Math.floor(Math.random() * 3) + 1;
          const isLeft = index % 2 === 0;

          return (
            <div
              key={index}
              className="bubble-icon-wrapper"
              style={{
                zIndex: randomZIndex,
                /*       marginTop: `${randomMarginTop}px`,
          marginLeft: `${randomMarginLeft}px`, */
                flexDirection: isLeft ? "row" : "row-reverse", // alternate direction
              }}
            >
              <div className="personIcon" style={{ margin: "0 10px" }}>
                <PersonIcon fill={fillColor} />
              </div>

              <div className="bubbleWraper">
                <div
                  className={`bubble ${tailSide}`}
                  style={{
                    backgroundColor: fillColor,
                    color: isYellow ? "#002068" : "#fff", // 👈 Add this line
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    borderTopLeftRadius: isLeft ? "0px" : "50px",
                    borderTopRightRadius: isLeft ? "50px" : "0px",
                  }}
                >
                  <div className="messageBlock" title={item.answer}>
                    {item.answer}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
